import {
  BLOOD_GLUCOSE_COLORS,
  BLOOD_PRESSURE_CATEGORIES,
  BLOOD_PRESSURE_COLORS,
} from "@/components/charts";

interface BloodGlucoseLegendProps {
  isDayView: boolean;
}

export const BloodGlucoseLegend = ({ isDayView }: BloodGlucoseLegendProps) => {
  // Only show legend for day view (filters hidden, show legend instead)
  if (!isDayView) return null;

  return (
    <div className="flex flex-wrap gap-3 justify-center">
      {Object.entries(BLOOD_GLUCOSE_COLORS).map(([label, color]) => (
        <div
          key={label}
          className="flex items-center gap-1.5 px-2 py-1 rounded-full bg-muted border border-border"
        >
          <div
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: color }}
          />
          <span className="text-xs text-muted-foreground font-medium">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

interface BloodPressureLegendProps {
  isDayView: boolean;
}

export const BloodPressureLegend = ({
  isDayView,
}: BloodPressureLegendProps) => {
  return (
    <div className="space-y-3">
      {/* Category Legend - Only for day view */}
      {isDayView && (
        <div className="flex flex-wrap gap-3 justify-center">
          {BLOOD_PRESSURE_CATEGORIES.map((category) => (
            <div key={category.label} className="flex items-center gap-1.5">
              <div
                className="w-2.5 h-2.5 rounded-full"
                style={{ backgroundColor: category.color }}
              />
              <span className="text-xs text-muted-foreground">
                {category.label}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Systolic/Diastolic Legend - Always show */}
      <div className="flex flex-wrap gap-4 justify-center">
        <div className="flex items-center gap-1.5">
          <div
            className="w-3 h-3 rounded"
            style={{ backgroundColor: BLOOD_PRESSURE_COLORS.systolic }}
          />
          <span className="text-xs text-muted-foreground font-medium">
            Systolic
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <div
            className="w-3 h-3 rounded"
            style={{ backgroundColor: BLOOD_PRESSURE_COLORS.diastolic }}
          />
          <span className="text-xs text-muted-foreground font-medium">
            Diastolic
          </span>
        </div>
      </div>
    </div>
  );
};
